{    
    let fn=function(e){e.preventDefault();return false;}

    let locks = {};

    window.VUTLockUnload=function(id) {
        locks[id] = true;
        // NELZE věšet jako eventListener, v chrome to přestalo bez varování fungovat...
        window.onunload=fn;
        window.onbeforeunload=fn;
        if (window.gl_debug) console.log("Aktivní zámky unloadu:", Object.keys(locks).join(', '));
    }

    window.VutUnloadLockActive = (id) => !!locks[id];
    window.VutUnloadLocked = (id) => !!Object.keys(locks).length;

    window.VUTUnlockUnload=function(id) {
        delete locks[id];
        if (!Object.keys(locks).length) {
            window.onunload=null;
            window.onbeforeunload=null;
            if (window.gl_debug) console.log("Unload není uzamčen.");
        } else {
            if (window.gl_debug) console.log("Aktivní zámky unloadu:", Object.keys(locks).join(', '));
        }
    }

    window.VUTUnlockUnloadAll=function() {
        locks = {}
        window.onunload=null;
        window.onbeforeunload=null;
        if (window.gl_debug) console.log("Unload není uzamčen.");
    }
}
